const MSK_OFFSET = '+03:00';
const HAS_TZ = /(?:Z|[+-]\d{2}:\d{2})$/;

/** Parses datetime from API: naive strings are treated as MSK, aware strings as-is. */
export function parseApiDateTime(iso: string): Date {
  const normalized = iso.includes('T') ? iso : iso.replace(' ', 'T');
  if (HAS_TZ.test(normalized)) return new Date(normalized);
  return new Date(`${normalized}${MSK_OFFSET}`);
}

const MSK_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  timeZone: 'Europe/Moscow',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

const MSK_DATE_OPTIONS: Intl.DateTimeFormatOptions = {
  timeZone: 'Europe/Moscow',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

/** Formats datetime as DD.MM.YYYY, HH:MM in Moscow time. */
export function formatDateTimeMsk(iso?: string | null): string {
  if (!iso) return '�';
  try {
    return parseApiDateTime(iso).toLocaleString('ru-RU', MSK_FORMAT_OPTIONS);
  } catch {
    return iso;
  }
}

/** Formats date-only fields (start_date, exam_date, end_date) as DD.MM.YYYY in Moscow time. */
export function formatDateMsk(iso?: string | null): string {
  if (!iso) return '';
  try {
    return parseApiDateTime(iso).toLocaleDateString('ru-RU', MSK_DATE_OPTIONS);
  } catch {
    return iso;
  }
}
